/**
 * ChangeLogIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ChangeLogIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M17 15.275c.47 0 .85.38.85.85V18l-.004.087a.85.85 0 0 1-.846.763h-2a.85.85 0 1 1 0-1.7h1.15v-1.025c0-.47.38-.85.85-.85m-6.913-3.121a.85.85 0 0 1 0 1.692L10 13.85H6.05a.85.85 0 1 1 0-1.7H10zM14 8.65a.85.85 0 1 1 0 1.7H6a.85.85 0 1 1 0-1.7zm0-3.32a.85.85 0 0 1 0 1.7H6a.85.85 0 1 1 0-1.7z" />
    <path
      fillRule="evenodd"
      d="M15 1.15A2.85 2.85 0 0 1 17.85 4v8.446a5.35 5.35 0 1 1-6.557 6.403H5A2.85 2.85 0 0 1 2.15 16V4A2.85 2.85 0 0 1 5 1.15zm1.5 12.825a3.65 3.65 0 1 0 0 7.3 3.65 3.65 0 0 0 0-7.3M5 2.85A1.15 1.15 0 0 0 3.85 4v12c0 .636.514 1.15 1.15 1.15h6.172a5.35 5.35 0 0 1 4.978-4.863V4A1.15 1.15 0 0 0 15 2.85z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ChangeLogIcon = makeIcon('ChangeLogIcon', ChangeLogIconSvg)
